export const EmptyIncDist = {
    role_ID: undefined,
    inc_Per: undefined,
    created_By: undefined,
    updated_By: undefined

}

